export function extractId(value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'object') {
        return extractId(value['@id'] ?? value.id);
    }
    const str = String(value);
    if (str.indexOf('/') === -1) return str;
    const parts = str.split('/').filter(Boolean);
    return parts[parts.length - 1] ?? null;
}

export function toIri(resourceName, value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'object' && value['@id']) return value['@id'];
    const str = String(value);
    if (str.startsWith('/')) return str;
    const id = extractId(value);
    return id ? `/api/${resourceName}/${id}` : '';
}

export function sameResource(a, b) {
    const aId = extractId(a);
    const bId = extractId(b);
    return aId !== null && bId !== null && String(aId) === String(bId);
}

export function getResourceKey(value) {
    return extractId(value) ?? '';
}